import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type InputWrapperProps = {
  required: boolean;
  disabled: boolean;
  className: string;
  labelPosition: 'top' | 'bottom' | 'left' | 'right';
  id: string;
  label: string;
  errorMessage?: string;
  children: React.ReactNode;
};

function InputWrapper({
  id,
  className,
  label,
  labelPosition,
  errorMessage,
  disabled,
  required,
  children,
}: InputWrapperProps) {
  const hasError = !!errorMessage && errorMessage !== '';
  const alignment = labelPosition === 'top' || labelPosition === 'bottom' ? 'column' : 'row';

  return (
    <span className={`input ${alignment} ${hasError ? 'error' : ''} ${className}`}>
      <label htmlFor={id} className={`${labelPosition} ${disabled ? 'disabled' : ''}`}>
        {label} {required && <small>(required)</small>}
      </label>
      <div className="input-error-wrapper">
        {children}
        <span className={`error-message ${labelPosition} ${hasError}`}>
          <FontAwesomeIcon icon="exclamation-circle" />
          <span>{errorMessage}</span>
          <span className="spacer" aria-hidden="true">
            spacer
          </span>
        </span>
      </div>
    </span>
  );
}

export default InputWrapper;
